import { ActiveOrder, QueryDataError } from '@/resources/types'
import { createContext, useContext } from 'react'

export type ActiveOrdersContextType = {
  activeOrders: ActiveOrder[]
  isPollingActive: boolean
  isFromWss: boolean
  isQueryFetching: boolean
  isFetched: boolean
  queryError?: QueryDataError | null
}

export const ActiveOrdersContext = createContext<ActiveOrdersContextType>({
  activeOrders: [],
  isPollingActive: false,
  isFromWss: false,
  isQueryFetching: false,
  isFetched: false,
})

const useActiveOrdersContext = () => {
  const context = useContext(ActiveOrdersContext)
  if (!context) {
    throw new Error(
      'useActiveOrdersContext must be used within ActiveOrdersContext'
    )
  }
  return context
}

export default useActiveOrdersContext
